export function updateEntities(state, value) {
  state.entities = value
}

export function updateReviewedEntities(state, value) {
  state.reviewedEntities = value
}

export function updateRegions(state, value) {
  state.regions = value
}

export function updateBusinesses(state, value) {
  state.businesses = value
}

export function updateSubscribers(state, value) {
  state.subscribers = value
}


export function updateCrawlers(state, value) {
  state.crawlers = value
}